import { z } from "zod";
import { ReadFormattingItemSchema } from "../readExcel/readExcel.schema";
export const ReadFormattingParamsSchema = z.object({
    readFormatting: z.array(ReadFormattingItemSchema).describe("Read formatting operations."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { ReadFormattingParamsSchema as ReadFormattingToolParamsSchema };
